import { t } from '@translations';
import { TextCodes } from '@api/types/translation/TextCodes';

// COLUMNS DEFINITION
//--------------------

export const getCustomerColumns = () => [
  {
    key: 'name',
    name: t(TextCodes.Customer.Block.CustomerName),
    sortable: true,
  },
  {
    key: 'customerNo',
    name: t(TextCodes.Customer.Block.CustomerNo),
    sortable: true,
  },
  {
    key: 'quantityOfUsers',
    name: t(TextCodes.Customer.Block.Users),
    sortable: true,
  },
  {
    key: 'lastOrderDate',
    name: t(TextCodes.Customer.Block.LastOrderDate),
    sortable: true,
  },
  {
    key: 'lastLoginDate',
    name: t(TextCodes.Customer.Block.LastLoginDate),
    sortable: true,
  },
];
